var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOxygen = function SvgOxygen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#oxygen_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M36 21.8h1.8V20h-5.4v1.8h1.8v1.8h-1.954a2.701 2.701 0 1 0 0 1.8H34.2v1.875a5.4 5.4 0 0 0-4.5 5.325v22.5a.9.9 0 0 0 .9.9h9a.9.9 0 0 0 .9-.9V32.6a5.4 5.4 0 0 0-4.5-5.325V25.4h4.5v-1.8H36zm-.9 7.2a3.6 3.6 0 0 0-3.6 3.6v1.8h7.2v-1.8a3.6 3.6 0 0 0-3.6-3.6m-3.6 25.2v-18h7.2v18zm-2.7-29.7a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0m15.3 10.8a3.6 3.6 0 0 1 7.2 0v5.4a3.6 3.6 0 0 1-7.2 0zm3.6-1.8a1.8 1.8 0 0 0-1.8 1.8v5.4a1.8 1.8 0 0 0 3.6 0v-5.4a1.8 1.8 0 0 0-1.8-1.8m7.2 6.3h-2.7V38h2.7a2.7 2.7 0 1 1 0 5.4.9.9 0 0 0-.9.9v.9h3.6V47h-4.5a.9.9 0 0 1-.9-.9v-1.8a2.7 2.7 0 0 1 2.7-2.7.9.9 0 1 0 0-1.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "oxygen_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35516",
    result: "shape"
  })))));
};
export default SvgOxygen;